import web from '../images/1.png';
import app from '../images/2.png';
import img1 from '../images/7.png';
import img2 from '../images/11.png';
import software from '../images/8.png';
import img3 from '../images/6.png'
import img4 from '../images/8.png'
import img5 from '../images/9.png'
import img6 from '../images/10.png'
import img7 from '../images/11.png'
import img8 from '../images/8.png'
import img9 from '../images/8.png'
import img10 from '../images/8.png'
import img11 from '../images/8.png'




const Pdata =[

    {
        id: 1,
        imgSrc: web,
        title:""
    },
    {
        id: 2,
        imgSrc:img1,
        title:"",
    },
    {
        id: 3,
        imgSrc: img7,
        title:""
    },
    {
        id: 4,
        imgSrc: software,
        title:" "
    },
    {
        id: 5,
        imgSrc:app,
        title:"",
    },
    
    {
        id: 6,
        imgSrc:img2,
        title:""
    },

    {
        id: 7,
        imgSrc:img3,
        title:""
    },

    {
        id: 8,
        imgSrc:img4,
        title:""
    },
     {
        id: 9,
        imgSrc:img5,
        title:""
    },
     {
        id: 10,
        imgSrc:img6,
        title:""
    },
     {
        id: 11,
        imgSrc:img7,
        title:""
    },
     {
        id: 12,
        imgSrc:img8,
        title:""
    },
     {
        id: 12,
        imgSrc:img9,
        title:""
    },
     {
        id: 12,
        imgSrc:img10,
        title:""
    },
     {
        id: 12,
        imgSrc:img11,
        title:""
    },

];
export default Pdata;